"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRenditions = exports.getVideoRenditionString = exports.getImageRenditionString = exports.ImageRenditionString = exports.VideoRenditionString = exports.VideoRenditionMediaString = void 0;

var _types = require("../types");

var VideoRenditionMediaString;
exports.VideoRenditionMediaString = VideoRenditionMediaString;

(function (VideoRenditionMediaString) {
  VideoRenditionMediaString["MD"] = "all and (min-width: 1024px) and (max-width: 1279px)";
  VideoRenditionMediaString["SM"] = "all and (max-width: 1023px)";
})(VideoRenditionMediaString || (exports.VideoRenditionMediaString = VideoRenditionMediaString = {}));

var VideoRenditionString;
exports.VideoRenditionString = VideoRenditionString;

(function (VideoRenditionString) {
  VideoRenditionString["MD"] = "jcr:content/renditions/cq5dam.video.mpeg1280.1280.720.mp4";
  VideoRenditionString["SM"] = "jcr:content/renditions/cq5dam.video.mpeg1024.1024.576.mp4";
  VideoRenditionString["ORIGINAL"] = "jcr:content/renditions/original";
})(VideoRenditionString || (exports.VideoRenditionString = VideoRenditionString = {}));

var ImageRenditionString;
exports.ImageRenditionString = ImageRenditionString;

(function (ImageRenditionString) {
  ImageRenditionString["LG"] = "jcr:content/renditions/cq5dam.web.1920.1080.jpeg";
  ImageRenditionString["MD"] = "jcr:content/renditions/cq5dam.web.1024.600.jpeg";
  ImageRenditionString["ORIGINAL"] = "jcr:content/renditions/original";
})(ImageRenditionString || (exports.ImageRenditionString = ImageRenditionString = {}));

var getImageRenditionString = function getImageRenditionString(path, size) {
  var isGif = path && path.split('.').pop() === 'gif';
  if (isGif) return path;
  return "".concat(path, "/").concat(ImageRenditionString[size] || ImageRenditionString.ORIGINAL);
};

exports.getImageRenditionString = getImageRenditionString;

var getVideoRenditionString = function getVideoRenditionString(path, size) {
  return "".concat(path, "/").concat(VideoRenditionString[size] || VideoRenditionString.ORIGINAL);
};

exports.getVideoRenditionString = getVideoRenditionString;

var useRenditions = function useRenditions(_ref) {
  var path = _ref.path,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'MD' : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _types.MediaTypes.IMAGE : _ref$type;

  if (type === _types.MediaTypes.IMAGE) {
    return path.map(function (item) {
      return getImageRenditionString(item, size);
    });
  } else {
    return path.map(function (item) {
      return getVideoRenditionString(item, size);
    });
  }
};

exports.useRenditions = useRenditions;